import { supabase } from './supabase';

// Upload a file to Supabase Storage and insert a cloud_files row
export async function uploadCloudFile(userId, file) {
  const timestamp = Date.now();
  const storagePath = `${userId}/${timestamp}_${file.name}`;

  const { error: uploadError } = await supabase.storage
    .from('spreadsheets')
    .upload(storagePath, file);

  if (uploadError) throw uploadError;

  const { data, error: insertError } = await supabase
    .from('cloud_files')
    .insert({
      user_id: userId,
      file_name: file.name,
      storage_path: storagePath,
      file_size: file.size,
    })
    .select()
    .single();

  if (insertError) throw insertError;

  return data;
}

// List all cloud files for a user, newest first
export async function listCloudFiles(userId) {
  const { data, error } = await supabase
    .from('cloud_files')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false });

  if (error) throw error;
  return data;
}

// Download a file blob from Storage
export async function downloadCloudFile(storagePath) {
  const { data, error } = await supabase.storage
    .from('spreadsheets')
    .download(storagePath);

  if (error) throw error;
  return data; // Blob
}

// Delete a cloud file from Storage and DB (views cascade)
export async function deleteCloudFile(fileId, storagePath) {
  const { error: storageError } = await supabase.storage
    .from('spreadsheets')
    .remove([storagePath]);

  if (storageError) throw storageError;

  const { error: dbError } = await supabase
    .from('cloud_files')
    .delete()
    .eq('id', fileId);

  if (dbError) throw dbError;
}

// List views for a cloud file
export async function listCloudViews(fileId) {
  const { data, error } = await supabase
    .from('cloud_views')
    .select('*')
    .eq('file_id', fileId)
    .order('created_at', { ascending: true });

  if (error) throw error;
  return data;
}

// Save a view for a cloud file
export async function saveCloudView(fileId, userId, name, settings) {
  const { data, error } = await supabase
    .from('cloud_views')
    .insert({
      file_id: fileId,
      user_id: userId,
      name,
      settings,
    })
    .select()
    .single();

  if (error) throw error;
  return data;
}

// Update a cloud view's settings
export async function updateCloudView(viewId, settings) {
  const { data, error } = await supabase
    .from('cloud_views')
    .update({ settings })
    .eq('id', viewId)
    .select()
    .single();

  if (error) throw error;
  return data;
}

// Delete a cloud view
export async function deleteCloudView(viewId) {
  const { error } = await supabase
    .from('cloud_views')
    .delete()
    .eq('id', viewId);

  if (error) throw error;
}
